module.exports = __webpack_public_path__ + "597129d67e512125bcfbb3ffd8dbd995.svg";